import { render, staticRenderFns } from "./recommendProduct.vue?vue&type=template&id=6e57fd10&scoped=true&"
import script from "./recommendProduct.vue?vue&type=script&lang=js&"
export * from "./recommendProduct.vue?vue&type=script&lang=js&"
import style0 from "./recommendProduct.vue?vue&type=style&index=0&id=6e57fd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57fd10",
  null
  
)

export default component.exports